import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import moment from 'config/Moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as JourneysActions } from 'store/ducks/journeys';

import { Validate } from 'common';
import { Page, Panel, Button, Loading } from 'components';
import { Form } from 'pages/Admin/Journeys/components';

class Create extends Component {
  state = {
    data: {
      name: '',
      description: '',
      available_from: null,
      available_until: null,
      east_face_quiz: '',
      west_face_quiz: '',
      north_face_quiz: '',
      south_face_quiz: '',
    },
    errors: {},
  };

  handleChange = data => {
    this.handleValidate();
    this.setState({ data });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      name: {
        required: true,
      },

      description: {
        required: true,
      },

      available_from: {
        required: true,
      },

      available_until: {
        required: true,
      },

      east_face_quiz: {
        required: true,
      },

      west_face_quiz: {
        required: true,
      },

      north_face_quiz: {
        required: true,
      },

      south_face_quiz: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSubmit = e => {
    e.preventDefault();

    if (!this.handleValidate()) return null;

    const { data } = this.state;

    this.props.createJourneyRequest({
      interview: {
        name: data.course.name,
        description: data.course.description,
        course: data.course,
        course_class: data.course_class,
        available_from: moment(data.available_from).format('YYYY-MM-DD HH:mm'),
        available_until: moment(data.available_until).format('YYYY-MM-DD HH:mm'),
      },
    });
  };

  render() {
    const { data, errors } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <div className="row align-items-center">
          <div className="col-6">
            <Page.Title>Nova Jornada</Page.Title>
          </div>

          <div className="col-6 text-right">
            <Button type="success" onClick={this.handleSubmit} disabled={create.loading}>
              {create.loading ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
            </Button>

            <Link to="/admin/journeys" className="btn btn-danger m-l-10">
              Cancelar
            </Link>
          </div>
        </div>

        <Panel>
          <Form data={data} errors={errors} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.journeys.create,
});

const mapActions = dispatch => bindActionCreators(JourneysActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);



// WEBPACK FOOTER //
// ./src/pages/Admin/Journeys/Create/index.js